module.exports = __webpack_public_path__ + "img/P22-en.a34a44de.png";